import React, { Component } from "react";
import { connect } from "react-redux";
import  toastr  from "COMPONENTS/ShowTostr/ShowTostr";
import { Row, Col, Button } from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getMessage } from "CONFIG/i18n";
import * as log from "loglevel";
import { sessionActions as actionFactory } from "CONFIG/ActionFactory";
import { inviteeAction as actionfactory } from "CONFIG/ActionFactory";
import { audioVideoAction } from "CONFIG/ActionFactory";

import "../AddInvitee/AddInvitee.less";
import "./WaitingArea.less";
import "../CommonComponents/Header/Header.less"
import AddInvitee from "../AddInvitee/AddInvitee";
import InviteHistory from "../AddInvitee/InviteHistory";
import EvictParticipantConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";

import ic_attendee from "ASSETS/Images/waiting_area/ic_attendee.svg";
import ic_attendee_presenter from "ASSETS/Images/waiting_area/ic_attendee_presenter.svg";
import ic_host from "ASSETS/Images/waiting_area/ic_host.svg";
import ic_host_presenter from "ASSETS/Images/waiting_area/ic_host_presenter.svg";
import ic_video from "ASSETS/Images/waiting_area/ic_video.svg";
import ic_video_off from "ASSETS/Images/waiting_area/ic_video_off.svg";
import ic_mic from "ASSETS/Images/waiting_area/ic_mic.svg";
import ic_mic_off from "ASSETS/Images/waiting_area/ic_mic_off.svg";
import ic_setting from "ASSETS/Images/waiting_area/ic_setting.svg";
import ic_setting_organiser from "ASSETS/Images/waiting_area/ic_setting_organiser.svg";
import ic_close from "ASSETS/Images/waiting_area/ic_close.svg";
import ic_arrow_down from "ASSETS/Images/waiting_area/ic_arrow_down.svg";
import ic_pull_down from "ASSETS/Images/waiting_area/ic_pull_down.svg";
import ic_edit from "ASSETS/Images/waiting_area/ic_edit.svg";

// CONSTANTS
import { USER_ADMISSION_STATUS, USER_ROLES, PARTICIPANT_STATUS, USER_STATIC, SESSION_SUBTYPES } from "UTILS/Constants";
import { mediaType } from "WEBSOCKET/constants";
import { isIE } from "react-device-detect";
import { mediaStatus } from "WEBSOCKET/constants";

import { getUserNameForSelectedLanguage, isMobileView, isTabletPortrait, setSMSMessage } from "UTILS/Utility";
import modalScrollBar from "../ModalScrollBar/ModalScrollBar";

// Selector
import { selectIsSMSEnabled } from "REDUX/Selector/OrganisationSelector";

class WaitingArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addInviteeManual: false,
      addInviteeHistory: false,
      currentSessionInvitees: [],
      buttonIndex: null,
      participantButtonIndex: null,
      showEvictParticipantConfirmationModal: false,
      evictParticipantId: null,
      //isReductionLogs: this.props.isReductionLogs ? (this.props.isReductionLogs.isEnable ? true : false) : false,
      isReductionLogs: true,
      inviteDropDown: false,
      settingDropDown: { status: false, id: null },
      showWaitingParticipants: true,
      showAdmittedParticipants: true,
      switchPresenter: false,
      showRerunSpeedTestConfirmationModal: false,
      rerunSpeedTestParticipantId: null,
    };
  }

  componentDidMount() {
    setSMSMessage(this, ["MANUAL_ENTRY_NON_SMS"]);
  }

  addInviteeManualHandle = () => {
    this.setState({ addInviteeManual: !this.state.addInviteeManual });
    this.setState({ inviteDropDown: false });
  };

  addInviteeHistoryHandle = () => {
    this.setState({ addInviteeHistory: !this.state.addInviteeHistory });
  };

  handleSendClick = (invitees, value) => {
    if (value) {
      this.setState({ addInviteeManual: !this.state.addInviteeManual });
    } else {
      this.setState({ addInviteeHistory: !this.state.addInviteeHistory });
    }
    actionFactory
    .inviteUser(this.props.sessionKey, invitees, this.props.language)
    .then(
      (data) => {
        toastr.info(getMessage("INVITATION_SENT"));
        log.info("Data:", data);
      },
      (error) => {
        toastr.info(getMessage("INVITATION_NOT_SENT"));
        log.error("ERROR: ", error);
      }
    );
  };

  handleAllowEdit = (allowEditAccess,participantId) => {
    // Only agent can change edit permission
    if(this.props.uniqueId === this.props.organiser){
      this.props.handleAllowEdit(allowEditAccess, participantId)
    }

    this.setState({
      settingDropDown: {
        ...this.state.settingDropDown,
        status: false
      }
    });
  }

  handleAddInviteHistory = () => {
    actionfactory.addInviteeAction(this.props.sessionKey).then(
      (data) => {
        if (
          data.data.invitees === undefined ||
                  data.data.invitees.length === 0
        ) {
          toastr.info(getMessage("NO_INVITEES"));
        } else {
          this.addInviteeHistoryHandle();
          this.setState({
            currentSessionInvitees: data.data.invitees,
          });
        }
        this.setState({ inviteDropDown: false });
      },
      (error) => {
        log.error("ERROR: ", error);
      }
    );
  };

  handleManualEntry = () => {
    return (
      <AddInvitee
        show={this.state.addInviteeManual}
        addInviteeManualHandle={this.addInviteeManualHandle}
        handleSendClick={this.handleSendClick}
        isSMSEnabled={this.props.isSMSEnabled}
      />
    );
  };
  handleInviteHistory = () => {
    return (
      <InviteHistory
        show={this.state.addInviteeHistory}
        addInviteeHistoryHandle={this.addInviteeHistoryHandle}
        currentSessionInvitees={this.state.currentSessionInvitees}
        handleSendClick={this.handleSendClick}
      />
    );
  };

  viewParticipantsButtons = (index) => {
    this.setState({ participantButtonIndex: index });
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleOutsideClickEvictParticipantModal);
  }

  handleOutsideClickEvictParticipantModal = (event) => {
    if (event.target.className == "modal fade show") {
      this.setState({
        showEvictParticipantConfirmationModal: false,
        evictParticipantId: null,
        evictParticipantName: null
      });
      document.removeEventListener("click", this.handleOutsideClickEvictParticipantModal);
    }
  }

  onOpenEvictParticipantConfirmationModal = (showConfirmationModal, participantId, participantName) => {
    this.setState({
      showEvictParticipantConfirmationModal: showConfirmationModal,
      evictParticipantId: participantId,
      evictParticipantName: participantName
    });
    this.closeModal = this.handleOutsideClickEvictParticipantModal.bind(this);
    document.addEventListener("click", this.handleOutsideClickEvictParticipantModal);
  }

  onOpenRerunSpeedTestConfirmationModal = (showConfirmationModal, participantId) => {
    this.setState({
      showRerunSpeedTestConfirmationModal: showConfirmationModal,
      rerunSpeedTestParticipantId: participantId,
    });
    if (showConfirmationModal) {
      this.setState({
        settingDropDown: {
          ...this.state.settingDropDown,
          status: false
        }
      });
    }    
  }

  handleAudioIcon = (e, participant) => {
    if (this.props.isOrganiser || participant.uniqueId === this.props.uniqueId) {
      e.stopPropagation();
      audioVideoAction.toggleMedia(
        this.props.sessionKey,
        mediaType.AUDIO,
        participant.audioStatus === mediaStatus.UNMUTED  && participant.uniqueId !== this.props.uniqueId
          ? mediaStatus.MUTED_BY_AGENT
          : participant.audioStatus === mediaStatus.UNMUTED 
            ? mediaStatus.MUTED
            : mediaStatus.UNMUTED,
        participant.uniqueId
      );
    }
  };

  handleVideoIcon = (e, participant) => {
    // restrict click of audio/video box
    if (this.props.isOrganiser || participant.uniqueId === this.props.uniqueId) {
      e.stopPropagation();
      audioVideoAction.toggleMedia(
        this.props.sessionKey,
        mediaType.AUDIO_VIDEO,
        participant.videoStatus === mediaStatus.UNMUTED && participant.uniqueId !== this.props.uniqueId
          ? mediaStatus.MUTED_BY_AGENT
          : participant.videoStatus === mediaStatus.UNMUTED
            ? mediaStatus.MUTED
            : mediaStatus.UNMUTED,
        participant.uniqueId
      );
    }
  };

  getAdmittedParticipantRow = (participant, index) => {
    if (participant) {
      try {
        let participantName = participant.role === USER_ROLES.AGENT
          ? getUserNameForSelectedLanguage(this.props.language, participant.userName)
          : participant.userName;

        const isPresenter = participant.uniqueId === this.props.presenter;
        let userIcon = participant.role === USER_ROLES.AGENT && isPresenter
          ? ic_host_presenter
          : participant.role === USER_ROLES.AGENT && !isPresenter
            ? ic_host
            : participant.role === USER_ROLES.USER && isPresenter
              ? ic_attendee_presenter
              : ic_attendee;
        let user = USER_ROLES.AGENT && isPresenter ? participantName : USER_STATIC.GUEST;
        return (
          <Row
            className="userListItem"
            key={index + "12"}
            onMouseOverCapture={() =>
              this.viewParticipantsButtons(
                index
              )
            }
            onMouseLeave={() =>
              this.viewParticipantsButtons(
                null
              )
            }
          >
            <Col lg="auto" className="noPadding userIcon w-auto">
              {/* agent or user icon */}
              <img
                src={userIcon}
                alt=""
              />
            </Col>
            { /* user name */}
            <Col
              className="noPadding userNameText overflowText"
              title={user}
            >
              {user}
            </Col>
            { /** edit icon */}
            {participant.allowEditAccess && (
              <Col lg="auto" className="w-auto noPadding editIcon hideElement ">
                <img
                  src={ic_edit}
                  alt=""
                />
              </Col>
            )}
            { /* mute / unmute  audio / video icons if audio / video call is going on */}
            <Col xs="auto" 
              className={
                this.props.sessionType === SESSION_SUBTYPES.SUPPORT_CENTER ?
                  this.props.isOrganiser 
                    ? "userListIcons"
                    : "guestUserListIcons"
                  : "hideElement"
              }>
              {(participant.mediaType === mediaType.AUDIO ||
                participant.mediaType === mediaType.AUDIO_VIDEO) &&
                <Button
                  color="link"
                  className={
                    this.props.isOrganiser 
                      ? "userListIcon"
                      : participant.uniqueId === this.props.uniqueId
                        ? "guestUserListIcon"
                        : "guestUserListIcon cursorDisabled"
                  }
                  onClick={(e) => this.handleAudioIcon(e, participant)}
                >
                  <img
                    src={
                      participant.audioStatus === mediaStatus.MUTED ||
                        participant.audioStatus === mediaStatus.MUTED_BY_AGENT
                        ? ic_mic_off
                        : ic_mic
                    }
                    title={
                      participant.audioStatus === mediaStatus.MUTED ||
                        participant.audioStatus === mediaStatus.MUTED_BY_AGENT
                        ? getMessage("UNMUTE_AUDIO")
                        : getMessage("MUTE_AUDIO")
                    }
                  />
                </Button>
              }
              {this.isVideoBlockShow() &&
                participant.mediaType === mediaType.AUDIO_VIDEO && (
                <Button
                  color="link"
                  className={
                    this.props.isOrganiser 
                      ? "userListIcon hideElement"
                      : participant.uniqueId === this.props.uniqueId
                        ? "guestUserListIcon hideElement"
                        : "guestUserListIcon cursorDisabled hideElement"
                  }
                  onClick={(e) => this.handleVideoIcon(e, participant)}
                >
                  <img
                    src={
                      participant.videoStatus === mediaStatus.MUTED ||
                          participant.videoStatus === mediaStatus.MUTED_BY_AGENT
                        ? ic_video_off
                        : ic_video
                    }
                    title={
                      participant.videoStatus === mediaStatus.MUTED ||
                          participant.videoStatus === mediaStatus.MUTED_BY_AGENT
                        ? getMessage("UNMUTE_VIDEO")
                        : getMessage("MUTE_VIDEO")
                    }
                  />
                </Button>
              )}
              {this.props.isOrganiser &&
                <div className="position-relative d-inline">
                  <button
                    className={participant.uniqueId === this.props.uniqueId
                      ? "userListIcon buttonDisabled hideElement"
                      : "userListIcon hideElement"
                    }
                    onClick={() => {
                      this.handleSettingDropDown(participant);
                    }}
                  >
                    <img
                      name={participant.id}
                      src={
                        participant.uniqueId === this.props.uniqueId
                          ? ic_setting_organiser
                          : ic_setting
                      }
                    />
                  </button>
                  {this.state.settingDropDown.status &&
                    participant.participantId === this.state.settingDropDown.id &&
                    this.renderSettingDropDown(participant)
                  }
                </div>}
            </Col>

            {/*this.isCobrowseBlockShow() && (
              <div className="pr-1 pl-1 d-flex align-items-center justify-content-center">
                {(participant.cobrowseStatus ||
                  participant.customerCoBrowseStatus) && (
                  <img src={ic_co_browse} alt="" className="" />
                )}
              </div>
            )*/}
          </Row>
        );
      } catch (error) {
        // supressing the error since participants list gets empty abruptly when agent refreshes the page
        console.log("Error while rendering admitted participants..supressing");
        return "";
      }
    }
  };

  //reserv the cobrowse space for all participant when one of the participant shown cobrowse icon
  isCobrowseBlockShow = () => {
    let showCobrowseBlock = false;
    this.props.admittedParticipants.forEach((participant) => {
      if (
        participant.cobrowseStatus ||
        participant.customerCoBrowseStatus
      ) {
        showCobrowseBlock = true;
        return;
      }
    });
    return showCobrowseBlock;
  };

  //reserv the video icon space for all participant when one of the participant shows video icon
  isVideoBlockShow = () => {
    let showVideoBlock = false;
    this.props.admittedParticipants.forEach((participant) => {
      if (participant.mediaType === mediaType.AUDIO_VIDEO) {
        showVideoBlock = true;
      }
    });
    return showVideoBlock;
  };

  getWaitingParticipantRow = (user, index) => {
    try {
      if(!this.state.isReductionLogs){
        const isPresenter = user.uniqueId === this.props.presenter;
        let userIcon = user.role === USER_ROLES.AGENT && isPresenter
          ? ic_host_presenter
          : user.role === USER_ROLES.AGENT && !isPresenter
            ? ic_host
            : user.role === USER_ROLES.USER && isPresenter
              ? ic_attendee_presenter
              : ic_attendee;

        return (
          <Row
            className="userListItem mx-0"
            key={index}
          >
            <Col lg="auto" className="px-0 userIcon w-auto">
              <img src={userIcon} alt="" />
            </Col>
            <Col
              className="overflowText userNameText px-0"
              title={user.userName}
            >
              {user.userName}
            </Col>
            <Col lg="auto" className="w-auto noPadding">
              <Button
                className="dismissButton whiteOnClick"
                onClick={() =>
                  this.props.admitOrRejectUserInSession(
                    false,
                    user.uniqueId,
                    true
                  )
                }
              >
                {getMessage("DISMISS")}
              </Button>
            </Col>
            <Col lg="auto" className="w-auto noPadding">
              <Button
                className="admitButton whiteOnClick"
                onClick={() =>
                  this.props.admitOrRejectUserInSession(
                    true,
                    user.uniqueId,
                    true
                  )
                }
              >
                {getMessage("ADMIT")}
              </Button>
            </Col>
          </Row>
        );
      }
    } catch (error) {
      // supressing the error since participants list gets empty abruptly when agent refreshes the page
      console.log("Error while rendering waiting participants..supressing");
      return "";
    }
  };

  handleToggle = (e) => {
    const name = e.target.name;
    this.setState({
      settingDropDown: { ...this.state.settingDropDown, status: false },
      switchPresenter: false,
      inviteDropDown: false,
      [name]: !this.state[name]
    });
  };

  handleInviteDropDown = () => {
    this.setState({
      settingDropDown: { ...this.state.settingDropDown, status: false },
      switchPresenter: false,
      inviteDropDown: !this.state.inviteDropDown
    });
  };

  handleSwitchPresenter = () => {
    this.setState({
      settingDropDown: { ...this.state.settingDropDown, status: false },
      inviteDropDown: false,
      switchPresenter: !this.state.switchPresenter
    });
  };

  handleSettingDropDown = (participant) => {
    const newSetting = {
      ...this.state.settingDropDown.status,
      status: !this.state.settingDropDown.status,
      id: participant ? participant.participantId : null,
    };
    this.setState({
      switchPresenter: false,
      inviteDropDown: false,
      settingDropDown: newSetting
    });
  };

  handleCopyToClipBoardIE = () => {
    if (window.clipboardData) {
      window.clipboardData.setData("Text", this.props.sessionLink);
      if (window.clipboardData.getData("Text")) {
        toastr.info(getMessage("SESSION_LINK_COPIED"));
        this.setState({ inviteDropDown: false });
      } else {
        toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
        this.setState({ inviteDropDown: false });
      }
    }
  };

  handleCopyToClipBoard = (_, result) => {
    if (result) {
      toastr.info(getMessage("SESSION_LINK_COPIED"));
      this.setState({ inviteDropDown: false });
    } else {
      toastr.info(getMessage("SESSION_LINK_NOT_COPIED"));
      this.setState({ inviteDropDown: false });
    }
  };
  renderInviteDropDown = () => {
    return (
      <Row className="inviteDropDown">
        <Col
          lg={12}
          className="inviteDropDownItem"
          onClick={this.addInviteeManualHandle}
        >
          {getMessage("INVITE")}
        </Col>
        {isIE ? (
          <Col
            lg={12}
            className="inviteDropDownItem"
            disabled={this.props.sessionLink ? false : true}
            onClick={this.handleCopyToClipBoardIE}
          >
            {getMessage("COPY_SESSION_LINK")}
          </Col>
        ) : (
          <CopyToClipboard
            text={this.props.sessionLink}
            onCopy={this.handleCopyToClipBoard}
          >
            <Col
              lg={12}
              className="inviteDropDownItem"
              disabled={this.props.sessionLink ? false : true}
            >
              {getMessage("COPY_SESSION_LINK")}
            </Col>
          </CopyToClipboard>
        )}
        <Col
          lg={12}
          className="inviteDropDownItem"
          onClick={this.handleAddInviteHistory}
        >
          {getMessage("INVITE_HISTORY")}
        </Col>
      </Row>
    );
  };

  renderSettingDropDown = (participant) => {
    const editMessage = participant.allowEditAccess
      ? "REMOVE_EDITING_PERMISSION"
      : "GRANT_EDITING_PERMISSION";
    return (
      <Row className="inviteDropDown">
        <Col
          lg={12}
          className="inviteDropDownItem hideElement"
          onClick={() =>
            this.handleAllowEdit(
              !participant.allowEditAccess,
              participant.uniqueId
            )
          }
        >
          {getMessage(editMessage)}
        </Col>
        <Col
          lg={12}
          className="inviteDropDownItem"
          onClick={() => {
            this.onOpenRerunSpeedTestConfirmationModal(
              true,
              participant.participantId,
            );
          }}
        >
          {getMessage("RERUN_SPEED_TEST")}
        </Col>
        <Col
          lg={12}
          className="inviteDropDownItem active"
          onClick={() => {
            this.onOpenEvictParticipantConfirmationModal(
              true,
              participant.participantId,
              participant.userName
            );
          }}
        >
          {getMessage("KICK_PARTICIPANT")}
        </Col>
      </Row>
    );
  };

  renderSwitchPresenterContainer = (admittedParticipants) => {
    return (
      <div className="switchPresenterContainer">
        {this.state.switchPresenter &&
          admittedParticipants &&
          admittedParticipants.length > 0 && (
          <div className="switchPresenterPopUp">
            <div className="switchPresenterHeading">
              <span>
                {getMessage("CHANGE_PRESENTER")}
              </span>
              <Button
                color="link"
                onClick={this.handleSwitchPresenter}
              >
                <img
                  src={ic_close}
                  alt=""
                />
              </Button>
            </div>
            <div className="switchPresenterList">
              {admittedParticipants.map((participant, index) => {
                return this.renderSwitchPresenter(participant, index);
              }
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderSwitchPresenter = (participant, index) => {
    const isPresenter = participant.uniqueId === this.props.presenter;
    let userIcon = participant.role === USER_ROLES.AGENT && isPresenter
      ? ic_host_presenter
      : participant.role === USER_ROLES.AGENT && !isPresenter
        ? ic_host
        : participant.role === USER_ROLES.USER && isPresenter
          ? ic_attendee_presenter
          : ic_attendee;

    let participantName = participant.role === USER_ROLES.AGENT
      ? getUserNameForSelectedLanguage(this.props.language, participant.userName)
      : participant.userName;
    return (
      <Row
        className="switchPresenterItem"
        key={index + "12"}
      >
        <Col lg="auto" className="userIcon w-auto">
          <img
            src={userIcon}
            alt=""
          />
        </Col>
        <Col
          className="w-auto userNameText overflowText noPadding"
          title={participantName}
        >
          {participantName}
        </Col>
        <Col lg="auto" className="w-auto noPadding">
          {isPresenter ? (
            <Button color="link" className="presenterButton">
              {getMessage("CURRENT_PRESENTER")}
            </Button>
          ) : (
            this.props.presenter !== participant.uniqueId &&
            participant.token && // Token check added to avoid make user presenter before user arrived
            <Button
              className="selectPresenterButton whiteOnClick"
              onClick={() => {
                this.props.makePresenter(participant);
                this.setState({ switchPresenter: false });
              }}
            >
              {getMessage("MAKE_PRESENTER")}
            </Button>
          )}
        </Col>
      </Row>
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.allParticipants !== this.props.allParticipants) {
      if (this.state.inviteDropDown) {
        this.setState({ inviteDropDown: false });
      }
    }

    if (this.state.settingDropDown.id !== prevState.settingDropDown.id) {
      this.setState({
        settingDropDown: {
          ...this.state.settingDropDown,
          status: true
        }
      });
    }
  }

  render() {
    let participant = null;
    let waitingParticipants = this.props.allParticipants.filter(
      (participant) =>
        participant.admissionStatus == USER_ADMISSION_STATUS.PENDING &&
        (participant.status === PARTICIPANT_STATUS.ACTIVE ||
          participant.status === PARTICIPANT_STATUS.WAITING)
    );
    let admittedParticipants = this.props.allParticipants.filter(
      (participant) =>
        participant.admissionStatus == USER_ADMISSION_STATUS.ADMITTED &&
        participant.status === PARTICIPANT_STATUS.ACTIVE
    );
    // console.log("admittedParticipants before:", admittedParticipants);
    if (admittedParticipants.length > 1) {
      let agentIndex = _.findIndex(admittedParticipants,
        participant => participant && participant.role === USER_ROLES.AGENT);
      let agentParticipant = admittedParticipants[agentIndex];
      admittedParticipants.splice(agentIndex, 1);
      admittedParticipants.push(agentParticipant);

      // Get participant i.e. user to display 'Allow Edit' title if allowEditAccess = true
      let participantIndex = _.findIndex(admittedParticipants,
        participant => participant && participant.uniqueId === this.props.uniqueId);
      participant = admittedParticipants[participantIndex];
    }
    // console.log("admittedParticipants after:", admittedParticipants);
    return (
      <div className="popUp waitingArea">
        {this.handleManualEntry()}
        {this.handleInviteHistory()}
        {(isMobileView(this.props.orientation)) &&
          this.state.switchPresenter
          ? (this.props.isOrganiser &&
            this.renderSwitchPresenterContainer(admittedParticipants))
          : (
            <div className="modal-wrapper" xs="8">
              <div className="waitingAreaHeader">
                <span className="waitingAreaTitle">
                  {getMessage("PARTICIPANTS_LIST")}
                </span>
                <div className="waitingAreaButtons">
                  {this.props.isOrganiser &&
                    <div className="position-relative hideElement">
                      <Button
                        className="inviteButton whiteOnClick"
                      >
                        <span onClick={this.addInviteeManualHandle}>
                          {getMessage("INVITE")}
                        </span>
                        <img
                          className={`arrowIcon ${this.state.inviteDropDown &&
                            `toggleActive`
                          }`}
                          onClick={this.handleInviteDropDown}
                          src={ic_arrow_down}
                          alt=""
                        />
                      </Button>
                      {this.state.inviteDropDown &&
                        this.renderInviteDropDown()}
                    </div>
                  }
                  <Button
                    color="link"
                    className="align-self-center noPadding closeButton"
                    onClick={this.props.handleParticipantsIcon}
                  >
                    <img
                      src={ic_close}
                      alt=""
                      className="cursorPointer"
                    />
                  </Button>
                </div>
              </div>
              <div className="waitingAreaContents">
                {/*  Hide this for future purposes */}
                {/* {this.props.isOrganiser &&
                  waitingParticipants &&
                  waitingParticipants.length > 0 && (
                  <div className="py-2 flexContainer">
                    <div className="pullDownHeading">
                      <span>
                        {getMessage("WAITING_AREA")}
                          &nbsp;&nbsp; ({waitingParticipants.length})
                      </span>
                      <img
                        name="showWaitingParticipants"
                        src={ic_pull_down}
                        alt=""
                        onClick={this.handleToggle}
                      />
                    </div>
                    <div className="flexContainer">
                      {this.state.showWaitingParticipants &&
                        waitingParticipants.map(
                          (participant, index) => {
                            return participant.uniqueId &&
                            this.getWaitingParticipantRow(participant, index)
                          }
                        )}
                    </div>
                  </div>
                )} */}
                <div className="flexContainer">
                  <div className="pullDownHeading">
                    <span>
                      {getMessage("PARTICIPANTS")}
                      &nbsp;&nbsp;({admittedParticipants.length})
                    </span>
                    <img
                      name="showAdmittedParticipants"
                      className="cursorPointer"
                      src={ic_pull_down}
                      onClick={this.handleToggle}
                      alt=""
                    />
                    {/*
                      Display Allow Edit title to agent and if admitted participants are there
                      OR 
                      display title to user because it shows switch in disabled state when allowEditAccess=true. 
                    */}
                    {((this.props.isOrganiser &&
                      admittedParticipants.length > 1) || (participant && this.props.uniqueId === participant.uniqueId && participant.uniqueId !== this.props.organiser && participant.allowEditAccess)) && <span className="userNameText pull-right">
                    </span>}
                  </div>
                  <div className="flexContainer">
                    {this.state.showAdmittedParticipants &&
                      admittedParticipants &&
                      admittedParticipants.length > 0 &&
                      admittedParticipants.map(
                        (participant, index) => {
                          return this.getAdmittedParticipantRow(participant, index);
                        }
                      )}
                  </div>
                  {this.props.isOrganiser &&
                    <Button
                      className="switchPresenterButton hideElement"
                      onClick={this.handleSwitchPresenter}
                    >
                      {getMessage("CHANGE_PRESENTER")}
                    </Button>
                  }
                  {this.renderSwitchPresenterContainer(admittedParticipants)}
                </div>
              </div>
            </div>
          )}
        {this.state.showEvictParticipantConfirmationModal &&
          <EvictParticipantConfirmationModal
            show={true}
            isDoubleButton={true}
            handleNoClick={() => { this.onOpenEvictParticipantConfirmationModal(false, null, null); }}
            handleYesClick={() => {
              this.props.evictAction(this.state.evictParticipantId);
              this.onOpenEvictParticipantConfirmationModal(false, null, null);
              this.handleSettingDropDown();
            }}
            message={getMessage("EVICT_PARTICIPANT_CONFIRMATION_TEXT",
              { participantName: (this.state.evictParticipantName) })}
            zIndex={2147483647}
          />
        }
        <EvictParticipantConfirmationModal
          show={this.state.showRerunSpeedTestConfirmationModal}
          isDoubleButton={true}
          handleNoClick={() => { this.onOpenRerunSpeedTestConfirmationModal(false, null); }}
          handleYesClick={() => {
            this.props.execSpeedTest(this.state.rerunSpeedTestParticipantId);
            this.onOpenRerunSpeedTestConfirmationModal(false, null);
          }}
          message={getMessage("SPEED_TEST_START_CONFIRM_MESSAGE")}
          zIndex={2147483647}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    // sessionKey: selectSessionKey(state)
    sessionType: state.SessionReducer.sessionSubType,
    isSMSEnabled: selectIsSMSEnabled(state),
    uriIdentifier: state.UserReducer.uriIdentifier
  };
};

export default modalScrollBar(connect(mapStateToProps)(WaitingArea));
